import React, { useState, useRef, useEffect } from "react";
import styles from "./PeopleUI.module.css";
import ui from "../DashboardUI.module.css";

export default function AddDropdown({
  canViewResources,
  onAddEmployee,
  onAddContractor,
  onAddResource,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [open]);

  const handle = (fn) => () => {
    setOpen(false);
    fn?.();
  };

  return (
    <div className={styles.addWrap} ref={wrapRef}>
      <button
        type="button"
        className={ui.addButton}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className={ui.icon}>＋</span> Add
      </button>
      {open && (
        <div className={styles.addMenu} role="menu">
          <button
            type="button"
            className={styles.addMenuItem}
            onClick={handle(onAddEmployee)}
            role="menuitem"
          >
            Employee
          </button>
          <button
            type="button"
            className={styles.addMenuItem}
            onClick={handle(onAddContractor)}
            role="menuitem"
          >
            Contractor
          </button>
          {canViewResources && (
            <button
              type="button"
              className={styles.addMenuItem}
              onClick={handle(onAddResource)}
              role="menuitem"
            >
              Resource
            </button>
          )}
        </div>
      )}
    </div>
  );
}
